 
import clsx from 'clsx';
import React, { FC } from 'react';
import { useTheme,Theme } from '@mui/material/styles';
import { Box } from '@mui/material';
interface IProps {
  styles?: {
    aspectContainer?: string | string[];
    aspectContent?: string | string[];
  };
  maxHeight?: string;
  children?: React.ReactNode;
}

const useStyles = (theme: Theme, { maxHeight }: { styles?: IProps['styles']; maxHeight?: string }) => ({
  aspectContainer: {
    backgroundColor: `${(theme.palette.background as any).shadedown_20} !important`,
    position: 'relative !important',
    '&::before': {
      content: '""',
      width: '1px !important',
      marginLeft: '-1px !important',
      float: 'left !important',
      height: '0 !important',
      paddingTop: `${maxHeight} !important`,
    },
    '&::after': {
      content: '""',
      display: 'table !important',
      clear: 'both !important',
    },
  },
  aspectContent: {
    display: 'flex !important',
    flexDirection: 'column !important',
    justifyContent: 'center !important',
    alignItems: 'center !important',
    position: 'absolute !important',
    top: '0 !important',
    right: '0 !important',
    bottom: '0 !important',
    left: '0 !important',
  },
});

export const AspectRatio: FC<IProps> = ({
   


  styles = {
    aspectContainer: '',
    aspectContent: '',
  },
  maxHeight = '56.25%',
  children,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme, { styles, maxHeight });

  return (
    <Box sx={{...classes.aspectContainer, ...(styles.aspectContainer as any)}}>
      <Box sx={{...classes.aspectContent, ...(styles.aspectContent as any)}}>
        {children}
      </Box>
    </Box>
  );
};
